import React from 'react';

// Shared sortable-table primitives for the admin triage tables
// (Pending brand handles + Suggested creators). Server-side sort: the header
// click updates a sort key/dir that the caller feeds into its query.

export type SortDir = 'asc' | 'desc';

export const THStyle: React.CSSProperties = {
  padding: '9px 12px', fontSize: 'var(--fs-caption)', fontWeight: 'var(--fw-semibold)',
  color: '#9ec3ff', textTransform: 'uppercase', letterSpacing: 0.4, whiteSpace: 'nowrap',
  userSelect: 'none',
};
export const TDStyle: React.CSSProperties = { padding: '9px 12px', verticalAlign: 'middle' };

/** A clickable column header that toggles server-side sort and shows the active arrow. */
export function SortHeader({ label, col, sortKey, sortDir, onSort, align = 'left' }: {
  label: string;
  col: string;
  sortKey: string | null;
  sortDir: SortDir;
  onSort: (k: string) => void;
  align?: 'left' | 'right';
}) {
  const active = sortKey === col;
  const arrow = <span style={{ opacity: active ? 1 : 0.25 }}>{active ? (sortDir === 'asc' ? '▲' : '▼') : '↕'}</span>;
  return (
    <th
      onClick={() => onSort(col)}
      title="Click to sort"
      style={{ ...THStyle, textAlign: align, cursor: 'pointer', color: active ? '#cfe3ff' : '#9ec3ff' }}
    >
      <span style={{ display: 'inline-flex', alignItems: 'center', gap: 4, justifyContent: align === 'right' ? 'flex-end' : 'flex-start' }}>
        {align === 'right' && arrow}
        {label}
        {align === 'left' && arrow}
      </span>
    </th>
  );
}
